/* @flow */
import * as React from 'react';

import { CHART_AXIS_FILL } from 'admin/constants/Charts';

type Props = {
  payload: { value: string },
  x: number,
  y: number,
};

function AdminStatisticsChartXAxisTick(props: Props) {
  const { payload, x, y } = props;
  const { value } = payload;

  return (
    <g transform={`translate(${x}, ${y})`}>
      <text x={0} y={0} dy={16} fill={CHART_AXIS_FILL} textAnchor="middle">
        {value}
      </text>
    </g>
  );
}

export default AdminStatisticsChartXAxisTick;
